import { fetchData, fetchGetData } from '../../services/apiClient';
import { API_ENDPOINTS } from '../../services/ApiConfig';

export interface ScenarioCreationResponse {
  message: string;
}

export const createScenarioAPI = async (payload: any) => {
  return fetchData<ScenarioCreationResponse>(API_ENDPOINTS.SCENARIO_INPUT.CREATE_SCENARIO, payload);
};

export const saveScenarioDraftAPI = async (payload: any): Promise<string> => {
  return fetchData(API_ENDPOINTS.SCENARIO_INPUT.CREATE_SCENARIO_DRAFT, payload);
};

export const deleteScenarioAPI = async (payload: any): Promise<string> => {
  return fetchData(API_ENDPOINTS.SCENARIO_LIBRARY.DELETE_SCENARIO, payload);
};

export const duplicateScenarioAPI = async (payload: any): Promise<string> => {
  return fetchData(API_ENDPOINTS.SCENARIO_LIBRARY.DUPLICATE_SCENARIO, payload);
};

export const getLatestYearMonthAPI = async (): Promise<{
  latest_year_month: string;
}> => {
  return fetchGetData(API_ENDPOINTS.SCENARIO_INPUT.LATEST_YEAR_MONTH);
};
